module.exports = __webpack_public_path__ + "static/img/95566.f489ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/95566.png
// module id = hM8T
// module chunks = 18